module.exports = __webpack_public_path__ + "a35d2bc1f356c07bbe5c571942e4ce9a.png";